import {Injectable} from '@angular/core';
import {HttpClient,} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {ErrorService, EventService} from '..';

import {ProjectBranch, ProjectBranchResponse, UpdateProjectBranchRequest} from '../models/branch';
import {ConfigService} from './config.service';
import {FileChecksum, FileChecksumResponse, UpdateFileChecksumRequest} from '../models';


@Injectable({ providedIn: 'root' })
export class ProjectBranchService {
    private projectBranchURL = ConfigService.getApiEndpoint() + 'v1/branch/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    search(query: any): Observable<ProjectBranchResponse> {
        return this.http.get<ProjectBranchResponse>(this.projectBranchURL + 'search', { params: query }).pipe(
            catchError(this.error.handleError('projectbranch.search', null))
        );
    }

    getOne(id: string): Observable<ProjectBranch> {
        return this.http.get<ProjectBranch>(this.projectBranchURL + id).pipe(
            catchError(this.error.handleError('projectbranch.getOne', null))
        );
    }

    getFileChecksum(id: string, query: any): Observable<FileChecksumResponse> {
        return this.http.get<FileChecksumResponse>(this.projectBranchURL + id + '/checksum', { params: query }).pipe(
            catchError(this.error.handleError('projectbranch.getFileChecksum', null))
        );
    }


    saveFileChecksumSettings(id: string, updateProtectionSettingsRequest: UpdateFileChecksumRequest): Observable<FileChecksum[]> {
        return this.http.put<FileChecksum[]>(this.projectBranchURL + id + '/filechecksumsettings', updateProtectionSettingsRequest).pipe(
            tap(_ => this.eventService.success('updated protection settings')),
            catchError(this.error.handleError('projectbranch.saveFileChecksum', null))
        );
    }

    updateProjectBranch(id: string, updateProjectBranchRequest: UpdateProjectBranchRequest): Observable<ProjectBranch> {
        return this.http.put<ProjectBranch>(this.projectBranchURL + id, updateProjectBranchRequest).pipe(
            tap(_ => this.eventService.success('updated project branch ')),
            catchError(this.error.handleError('projectbranch.updateProjectBranchRequest', null))
        );
    }
}
